export { default as BellCrossedSolidIcon } from './BellCrossedSolidIcon';
